import { OutlineElement } from '@phase2/outline-core';
import { html, TemplateResult, CSSResultArray } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { AdoptedStyleSheets } from '@phase2/outline-adopted-stylesheets-controller';
import componentStyles from './pc-personal-quote.css.lit';

import '../pc-container/pc-container';
import globalStyles from './pc-personal-quote.lightDom.css.lit';
import { classMap } from 'lit/directives/class-map.js';

/**
 * Personal quote component
 * @element pc-personal-quote
 * @slot - This element has a default slot
 * @attr full-bleed
 * @attr pc-hero
 */
@customElement('pc-personal-quote')
export class PCPersonalQuote extends OutlineElement {
  static styles: CSSResultArray = [componentStyles];
  adoptedStylesheets: AdoptedStyleSheets;

  hasImage = false;

  @property({ type: Boolean, reflect: true, attribute: 'full-bleed' })
  fullBleed: boolean;

  @property({ type: Boolean, reflect: true, attribute: 'pc-hero' })
  pcHero = false;

  @property({ type: Boolean, reflect: true, attribute: 'pc-story-carousel' })
  pcStoryCarousel = false;

  connectedCallback() {
    super.connectedCallback();
    this.adoptedStylesheets = new AdoptedStyleSheets(globalStyles);
    this.addController(this.adoptedStylesheets);
    this.hasImage = Boolean(this.querySelector('[slot="image"]'));
  }

  render(): TemplateResult {
    const classes = {
      'personal-quote': true,
      'without-image': !this.hasImage,
      'pc-hero': this.pcHero,
      'pc-hero-carousel': this.pcStoryCarousel,
    };
    return html`
      <div class=${classMap(classes)}>
        <pc-container class="container" ?full-bleed=${this.fullBleed}>
          <div class="image">
            <slot name="image"></slot>
          </div>
          <blockquote class="quote">
            <slot name="content"></slot>
            <slot name="footer"></slot>
          </blockquote>
        </pc-container>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'pc-personal-quote': PCPersonalQuote;
  }
}
